export default {
  outbound: 'Voo de ida',
  inbound: 'Regresso',
  hide: 'Ocultar',
  details: 'Detalhes',
}
